import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { styles } from "./styles";

class LinkExpired extends React.Component {
  render() {
    const { classes, text, onBackToLogin } = this.props;

    return (
      <div className={"box box-default " + classes.link_expired_card}>
        <div className={"box-body text-center " + classes.link_expired_body}>
          <h2 className={classes.link_expired_title}>
            <span className={classes.link_expired_title_text}>
              Link Expired
              <span className={"material-icons " + classes.link_expired_icon}>
                link_off
              </span>
            </span>
          </h2>
          <p className={classes.link_expired_text}>{text}</p>
          {onBackToLogin && (
            <button
              type="button"
              className={classes.link_expired_link}
              onClick={onBackToLogin}
            >
              Back to login
            </button>
          )}
        </div>
      </div>
    );
  }
}

LinkExpired.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.string,
  onBackToLogin: PropTypes.func
};

LinkExpired.defaultProps = {
  text: "This approval link is no longer valid.",
  onBackToLogin: null
};

export default withStyles(styles)(LinkExpired);
